module.exports = __webpack_public_path__ + "img/1762863299853-GFUSNL8a.9a1e8224.png";